import Image from 'next/image';
import type { ReactElement } from 'react';

import Title from '@/components/atoms/Title';

import {
  Avatar,
  FeedbackCard,
  FeedbackGrid,
  FeedbackText,
  FeedbackWrapper,
  Rating,
  UserDetails,
  UserInfo,
  UserName,
} from './Feedback.styled';

const feedbackData = [
  {
    name: 'Laura M.',
    image: '/static/images/avatars/laura.jpg',
    text: 'Jestem zachwycona tym przewodnikiem, bardzo ułatwił mi zaplanowanie wyjazdu na Teneryfę! Wszystkie atrakcje zebrane w jednym miejscu plus mega dużo poleceń restauracji, plaż i aktywności na wyspie. A do tego przepiękne opracowanie wizualne, polecam!',
    rating: 5,
  },
  {
    name: 'Elżbieta B.',
    image: '/static/images/avatars/ela.png',
    text: 'Bestseller na rynku przewodników turystycznych! Profesjonalne opracowanie, barwny język i najwyższej jakości zdjęcia sprawią, że od dziś będziesz planował podróż swojego życia! Number one you must have!!!',
    rating: 5,
  },
  {
    name: 'Bożena W.',
    image: '/static/images/avatars/bozena.png',
    text: 'Czytanie przewodnika o Teneryfie było wspaniałą przygodą! Zajmujące treści ciekawie podane sprawiały, że odbywałam wirtualną podróż . Wyobraźnię podsycały wspaniałe zdjęcia których jest tu mnóstwo a także informacje praktyczne. To przewodnik dla każdego kto jest ciekawy świata! Gorąco polecam!!',
    rating: 5,
  },
  {
    name: 'Beata Sz.',
    image: '/static/images/avatars/beata.jpg',
    text: 'Świetny, bardzo rzetelnie opracowany przewodnik. Żałuję, że go nie miałam podczas swojej pierwszej podróży na Teneryfę. Jest w nim wszystko co potrzeba do zorganizowania sobie udanego pobytu na tej pięknej wyspie: praktycznie wskazówki, opis bardzo wielu ciekawych miejsc i atrakcji, noclegi, trasy piesze, punkty widokowe, plaże, super pomocne mapki, wiele ciekawostek kulturowych i geograficznych i mnóstwo bardzo dobrych porad i przydatnych informacji. A do tego piękne zdjęcia i znakomity przewodnik kulinarny z bardzo wieloma rekomendacjami, z których każdy skorzysta.  Słowem must have. Szczerze polecam!',
    rating: 5,
  },
];

export const Feedback = (): ReactElement => (
  <FeedbackWrapper>
    <Title>Co mówią czytelnicy?</Title>
    <FeedbackGrid>
      {feedbackData.map(feedback => (
        <FeedbackCard key={feedback.name}>
          <UserInfo>
            <Avatar>
              <Image
                sizes="100px"
                src={feedback.image}
                alt={feedback.name}
                fill
              />
            </Avatar>
            <UserDetails>
              <UserName>{feedback.name}</UserName>
            </UserDetails>
          </UserInfo>
          <Rating>{'⭐'.repeat(feedback.rating)}</Rating>
          <FeedbackText>{feedback.text}</FeedbackText>
        </FeedbackCard>
      ))}
    </FeedbackGrid>
  </FeedbackWrapper>
);
